"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GalleryControls;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _carouselControl = require("../../sections/smart-testimonials-section/carousel-control");
/* eslint-disable max-len */

const ActiveIcon = /*#__PURE__*/(0, _react2.styled)(_carouselControl.IconWrapper)({
  name: "ActiveIcon",
  class: "pl-a1c7o0m1"
});
const PaginationButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "PaginationButton",
  class: "pl-p15lmvkq"
});
const PrevButton = /*#__PURE__*/(0, _react2.styled)(PaginationButton)({
  name: "PrevButton",
  class: "pl-p1n2qzfe"
});
const NextButton = /*#__PURE__*/(0, _react2.styled)(PaginationButton)({
  name: "NextButton",
  class: "pl-n1om18nk"
});
const SlideControls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SlideControls",
  class: "pl-s1bikb0g"
});

/**
 * SlideControlButtons component.
 *
 * @param {Object} props React props
 * @param {string} props.prevCallback The function triggered when clicking the previous button
 * @param {string} props.nextCallback The function triggered when clicking the next button
 * @param {string} props.timeout How long the progress circle should take to complete
 * @param {string} props.rate How fast in ms does the progress circle update progress
 * @param {string} props.disableAnimation Whether or not animations should be triggered
 * @param {array} props.nextButtonAriaLabel THe aria label text for the Next Button
 * @param {string} props.prevButtonAriaLabel The aria label text for the Previous Button
 * @param {string} props.dataCy The data-cy attribute for this component
 * @returns {React.ReactElement} SlideControlButtons component
 * @public
 */
function GalleryControls({
  prevCallback,
  nextCallback,
  nextButtonAriaLabel = 'Next',
  prevButtonAriaLabel = 'Previous',
  disableNext,
  disablePrev,
  dataCy = 'gallery-controls'
}) {
  return /*#__PURE__*/_react.default.createElement(SlideControls, {
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(PrevButton, (0, _extends2.default)({
    "aria-label": prevButtonAriaLabel,
    onClick: prevCallback
  }, _patternLibraryUtils.tracking.create(`${dataCy}-prev-button`, true, true), {
    "data-cy": `${dataCy}-prev`,
    disabled: disablePrev
  }), /*#__PURE__*/_react.default.createElement(ActiveIcon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement(NextButton, (0, _extends2.default)({
    "aria-label": nextButtonAriaLabel,
    onClick: nextCallback
  }, _patternLibraryUtils.tracking.create(`${dataCy}-next-button`, true, true), {
    "data-cy": `${dataCy}-next`,
    disabled: disableNext
  }), /*#__PURE__*/_react.default.createElement(ActiveIcon, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right",
    "aria-hidden": "true"
  }))));
}
GalleryControls.propTypes = {
  prevCallback: _propTypes.default.func,
  nextCallback: _propTypes.default.func,
  prevButtonAriaLabel: _propTypes.default.string,
  nextButtonAriaLabel: _propTypes.default.string,
  disablePrev: _propTypes.default.bool,
  disableNext: _propTypes.default.bool,
  dataCy: _propTypes.default.string
};